@if (!universalService.isMobileDevice) {
  <div class="modal fade" id="share-discard-modal" aria-labelledby="share-discard-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': universalService.popUpToBeOpened =='shareDiscardPopUp' ? 'block' : 'none','opacity': 1, 'z-index': 99999,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90">
        <div class="modal-header">
          <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
          <h5 class="mb-0">Discard Changes</h5>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="discard-confimration mt-3">
            <ul>
              <li class="text">Do you want to discard changes?</li>
              <li class="subtext"></li>
            </ul>
          </div>
        </div>
        <div class="modal-footer border-top-0 p-3">
          <div class="discard-btn-main">
            <button (click)="discardShare()" tabindex="-1">Discard</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}




@if (universalService.isMobileDevice) {
  <div class="modal fade slide-in-fwd-center" id="m-share-discard-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="m-share-discard-modal" aria-hidden="true" [ngStyle]="{'display': universalService.popUpToBeOpened == 'shareDiscardPopUp' ? 'block' : 'none', 'opacity': 1,'z-index': 99999, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content animated bounceInUp fixed-bottom">
        <div class="modal-header">
          <h6>Do you want to discard changes?</h6>
        </div>
        <div class="modal-body">
          <div class="m-cancel-button">
            <button (click)="closePopUp()">CANCEL</button>
          </div>
          <div class="m-discard-button pt-3">
            <button (click)="discardShare()">DISCARD</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}